import { h, Component } from "preact";

import DropdownProjectsMenu from "./DropdownProjectsMenu";
import DropdownMenu from "./DropdownMenu";
import gear from "./images/gear.svg";
import selectTriangle from "./images/select_triangle_white.svg";

class UserWidget extends Component {
  constructor(props) {
    super(props);
  }

  render({
    avatarUrl,
    displayName,
    onClick,
    onClickWheel,
    isAdmin,
    toggleProjectList,
    showProjectsMenu,
    isLoading,
    isMegaMenuOpen,
    isLinkListOpen,
    isProjectListOpen,
    accountUrl,
    projects,
    goToProject,
    goToLink,
    userId,
    accountMenu,
    adminOnly,
    betaToggle,
    client
  }) {
    if (!isLoading && !displayName && !adminOnly) {
      return (
        <div class="user-widget" role="menu">
          <a
            class="user-widget__log-in"
            href={accountUrl}
            rel="noopener noreferrer"
          >
            Log in
          </a>
          <a
            class="user-widget__free-trial"
            href={`${accountUrl}/platform/trial/general/setup`}
            rel="noopener noreferrer"
          >
            <strong>Free Trial</strong>
          </a>
        </div>
      );
    }
    return (
      <div class={`user-widget${betaToggle ? " beta-option" : ""}`}>
        {showProjectsMenu && !adminOnly && (
          <div class="dropdown-wrapper">
            <a
              class={`user-widget-nav-button user-widget__projects_menu_toggle ${isProjectListOpen &&
                "user-widget__projects_menu_toggle--active"}`}
              onClick={e => {
                e.preventDefault();
                toggleProjectList();
              }}
              href
              aria-haspopup="true"
              aria-expanded={isProjectListOpen}
            >
              <span>Projects</span>
              <img src={selectTriangle} alt="chevron" />
            </a>
            <DropdownProjectsMenu
              open={isProjectListOpen}
              menuName={"user-widget__dropdown__menu--projects"}
              onChange={goToProject}
              values={projects.reduce((acc, current) => {
                if (!acc[current.cluster_label]) {
                  acc[current.cluster_label] = [];
                }
                acc[current.cluster_label].push({
                  label: current.title,
                  value: current.id,
                  uri: current.uri
                });
                return acc;
              }, {})}
            />
          </div>
        )}
        {!adminOnly && (
          <div
            class={`dropdown-wrapper${
              this.props.nameOrAvatar ? " name-or-pic" : ""
            }`}
          >
            {this.props.nameOrAvatar ? (
              <a
                class={`user-widget-nav-button user-widget__accounts_menu_toggle ${isLinkListOpen &&
                  "user-widget__accounts_menu_toggle--active"}`}
                onClick={e => {
                  e.preventDefault();
                  onClick();
                }}
                href
                aria-haspopup="true"
                aria-expanded={isLinkListOpen}
              >
                {avatarUrl && !avatarUrl.endsWith("user-default.png") ? (
                  <img
                    class="user-widget__avatar"
                    src={avatarUrl}
                    alt={displayName}
                  />
                ) : (
                  <div class="user-widget__user_name">{displayName}</div>
                )}
              </a>
            ) : (
              <a
                class={`user-widget-nav-button user-widget__accounts_menu_toggle ${isLinkListOpen &&
                  "user-widget__accounts_menu_toggle--active"}`}
                onClick={e => {
                  e.preventDefault();
                  onClick();
                }}
                href
                aria-haspopup="true"
                aria-expanded={isLinkListOpen}
              >
                <img
                  class="user-widget__avatar"
                  src={
                    avatarUrl
                      ? avatarUrl
                      : `${accountUrl}/profiles/blimp_profile/themes/bootstrap_accounts/images/user-default.png`
                  }
                  alt={displayName}
                />
                <div class="user-widget__user_name">{displayName}</div>
              </a>
            )}
            <DropdownMenu
              open={isLinkListOpen}
              menuName={"user-widget__dropdown__menu--account"}
              onChange={goToLink}
              values={accountMenu.map(l => ({
                label: l.label,
                value: l.value
                  .replace("{userId}", userId)
                  .replace("{accountUrl}", accountUrl)
              }))}
              userId={userId}
              betaToggle={betaToggle}
              client={client}
            />
          </div>
        )}
        {isAdmin && (
          <a
            class={`user-widget-nav-button user-widget__toggle ${isMegaMenuOpen &&
              "user-widget__toggle--active"}`}
            onClick={e => {
              e.preventDefault();
              onClickWheel(e);
            }}
            href
            aria-haspopup="true"
            aria-expanded={isMegaMenuOpen}
          >
            <img class="user-widget__toggle_img" src={gear} alt="support" />
          </a>
        )}
      </div>
    );
  }
}

export default UserWidget;



// WEBPACK FOOTER //
// ./src/UserWidget.js